"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const iconList_1 = require("./iconList");
/**
 * Icon component
 *
 * @visibleName Icon
 */
const IconComponent = (_a) => {
    var { children, name } = _a, rest = (0, tslib_1.__rest)(_a, ["children", "name"]);
    const RenderIcon = (0, iconList_1.getIcon)(name);
    if (!RenderIcon)
        return null;
    return (0, jsx_runtime_1.jsx)(RenderIcon, Object.assign({}, rest), void 0);
};
exports.Icon = IconComponent;
//# sourceMappingURL=Icon.js.map